import * as types from "../actions/index";
export default function(state = true, action) {
  switch (action.type) {
    case types.OVERLAY_CLICKABLE:
      return action.payload;
    // no default
  }
  return state;
}
